<section class="section-white" *ngIf="featuresData">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-48">{{ featuresData?.header }}</h2>
    <div class="product-blog-container">
      <div class="product-blog-row">
        <div
          class="product-blog padd-48 grey-100 no-cursor gap-24"
          *ngFor="let card of featuresData.cards"
        >
          <h3 class="item-title">
            <a
              class="link-xl"
              href="{{ card.fields.link | urlParams: queryParams }}"
              target="{{ card.fields.linkType }}"
            >
              {{ card.fields.title }}<span class="arrow">&rarr;</span>
            </a>
          </h3>
          <a
            class="link-xl"
            href="{{ link.fields.hyperLinks | urlParams: queryParams }}"
            target="{{ link.fields.actionType }}"
            *ngFor="let link of card.fields.linkedElements"
          >
            <img
              width="20"
              class="me-2"
              src="{{ link.fields.icon.fields.file.url }}"
              alt="{{ link.fields.icon.fields.title }}"
            />
            {{ link.fields.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
